// extracted by mini-css-extract-plugin
export default {"wrapper":"V4-z"};